import { Injectable } from '@angular/core';

import { Subject } from 'rxjs';

/**
 * service to make DatatableComponent aware of changes to
 * input bindings of DataTableColumnDirective
 */
@Injectable()
export class ColumnChangesService {
  private columnInputChanges = new Subject<void>();

  get columnInputChanges$(): Subject<void> {
    return this.columnInputChanges;
  }

  onInputChange(): void {
    this.columnInputChanges.next();
  }
}
